import { ModalContentStyled } from "../../Modals/styled/ModalsStyled";
import { RegisterEmailCheckModalIconContainerStyled } from "../../Modals/styled/RegisterEmailCheckModalStyled";
import { BinIcon } from "../../../components/icon/Icon";
import { Button, Form } from "react-bootstrap";
import { Loader } from "../../../components/Loader/Loader";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { createStructuredSelector } from "reselect";
import {
    makeSelectAppFormError,
    makeSelectAppLoggedInProcess,
    getRegistrationData
} from "../../../app/appSelectors";
import { connect } from "react-redux";
import { useCallback, useEffect } from "react";
import { resetFormErrorAction } from "../../../app/appActions";

function RegisterEmailCheck(props) {
    const {formError, loggedInProcess, onClose, onSubmit, registerData, resetFormError} = props;
    const {getLangPath} = useLangContext();

    useEffect(() => {
        if (!registerData?.email) {
            onClose();
        }
    }, [onClose, registerData]);

    const handleChange = useCallback(() => {
        if (formError) {
            resetFormError();
        }
    }, [formError, resetFormError]);

    return <ModalContentStyled className="h-100">
        <div className="d-flex flex-column justify-content-center h-100">
            <div className="d-flex justify-content-center mt-sm-4">
                <RegisterEmailCheckModalIconContainerStyled>
                    <BinIcon name="IcEnvelope" style={{fill: 'var(--icon-primary-color)'}}/>
                </RegisterEmailCheckModalIconContainerStyled>
            </div>
            <h2 className="text-center mt-2rem">{getLangPath('sign_up.check_email_description')}</h2>
            <Form onSubmit={onSubmit}>
                <Form.Group className="mt-2rem">
                    <Form.Control defaultValue={registerData?.email} name="email" type="email"
                                  placeholder={getLangPath('promo.fx.errors.email1')}
                                  isInvalid={formError} onChange={handleChange}/>
                    {
                        formError && <>
                            <Form.Control.Feedback type="invalid">
                                {getLangPath(formError)}
                            </Form.Control.Feedback>
                        </>
                    }
                    <div className="d-flex mt-2 font-size-14">
                        <BinIcon name="IcAttention" style={{fill: 'var(--color-secondary-active)'}}/>
                        <p className="mb-0 ms-2 text-secondary">{getLangPath('sign_up.check_email_hint')}</p>
                    </div>
                </Form.Group>
                <div className="d-flex flex-column mt-2rem">
                    <Button
                        size="lg"
                        variant="primary"
                        type="submit"
                    >
                        {getLangPath('sign_up.check_email_button_submit')}
                    </Button>
                    <Button
                        size="md"
                        variant="outline-info"
                        className="mt-3"
                        onClick={onClose}
                    >
                        {getLangPath('sign_up.check_email_button_back')}
                    </Button>
                </div>
            </Form>
        </div>
        <Loader show={loggedInProcess}/>
    </ModalContentStyled>
}

const mapStateToProps = createStructuredSelector({
    formError: makeSelectAppFormError(),
    loggedInProcess: makeSelectAppLoggedInProcess(),
    registerData: getRegistrationData,
});

const mapDispatchToProps = (dispatch) => ({
    resetFormError: (payload) => dispatch(resetFormErrorAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterEmailCheck);
